module.exports = __webpack_public_path__ + "img/phone-outgoing-svgrepo-com.4a459420.svg";